// RecentProjectThree.jsx
import React, { useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom"; // If you're on Next.js, swap to: import Link from "next/link";

import leafImage from "@/assets/images/resources/leaf.png";
import projectImg1 from "@/assets/images/project/1.jpeg";
import projectImg2 from "@/assets/images/project/2.jpeg";
import projectImg3 from "@/assets/images/project/3.jpeg";
import projectImg4 from "@/assets/images/project/4.jpeg";

export default function RecentProjectThree() {
  const sliderRef = useRef(null);
  const sliderApiRef = useRef(null);

  const projects = useMemo(
    () => [
      {
        image: projectImg1,
        title: "Solutions durables",
        line1: "SOLUTIONS",
        line2: "DURABLES",
        description:
          "Des pratiques agricoles responsables pour préserver les ressources naturelles sur le long terme.",
        delay: "300ms",
      },
      {
        image: projectImg2,
        title: "Agriculture raisonnée",
        line1: "AGRICULTURE",
        line2: "RAISONNÉE",
        description:
          "Une approche équilibrée qui concilie rendement, respect des sols et bien-être animal.",
        delay: "600ms",
      },
      {
        image: projectImg3,
        title: "Techniques biologiques",
        line1: "TECHNIQUES",
        line2: "BIOLOGIQUES",
        description:
          "Des méthodes de culture sans produits chimiques de synthèse pour des récoltes plus saines.",
        delay: "900ms",
      },
      {
        image: projectImg4,
        title: "Produits naturels",
        line1: "PRODUITS",
        line2: "NATURELS",
        description:
          "Des produits issus d’une agriculture respectueuse de l’environnement et des consommateurs.",
        delay: "1200ms",
      },
    ],
    []
  );

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (typeof window === "undefined" || !sliderRef.current) return;

      const { tns } = await import("tiny-slider/src/tiny-slider");
      if (cancelled || !sliderRef.current) return;

      const api = tns({
        container: sliderRef.current,
        items: 1,
        slideBy: 1,
        gutter: 16,
        edgePadding: 0,
        autoplay: false,
        controls: false,
        nav: false,
        mouseDrag: true,
        swipeAngle: false,
        speed: 400,
        responsive: {
          576: {
            items: 2,
            gutter: 12,
          },
          768: {
            items: 2,
            gutter: 16,
          },
          992: {
            items: 3,
            gutter: 12,
          },
          1200: {
            items: 4,
            gutter: 5,
          },
        },
      });

      if (cancelled && typeof api.destroy === "function") {
        api.destroy();
        return;
      }

      sliderApiRef.current = api;
    })();

    return () => {
      cancelled = true;
      const api = sliderApiRef.current;
      sliderApiRef.current = null;
      if (api && typeof api.destroy === "function") {
        api.destroy();
      }
    };
  }, []);

  return (
    <section className="recent_project_three recent-project-three-responsive">
      <div className="container-fullwidth recent-project-three__inner">
        <div className="block-title text-center">
          <p>Explorer des projets</p>
          <h3>Nos projets récents</h3>
          <div className="leaf">
            <img src={leafImage} alt="Feuille décorative" />
          </div>
        </div>

        <div className="recent_project_three_carousel">
          <div className="my-slider" ref={sliderRef}>
            {projects.map((project, index) => (
              <div
                className="project_three_single wow fadeInUp"
                key={index}
                data-wow-delay={project.delay}
              >
                <div className="project_three_image">
                  <img src={project.image} alt={project.title} />

                  <div className="project_three_content">
                    <h2>
                      {project.line1}
                      <br />
                      {project.line2}
                    </h2>
                  </div>

                  <div className="project_three_hover_box">
                    <h2>{project.title}</h2>
                    <p>{project.description}</p>
                    <div className="project_three_btn">
                      {/* React Router */}
                      <Link
                        to="/projects_detail"
                        className="thm-btn project_three_btn_hover"
                      >
                        En savoir plus
                      </Link>

                      {/* Next.js version (uncomment if needed)
                      <Link
                        href="/projects_detail"
                        className="thm-btn project_three_btn_hover"
                      >
                        Read More
                      </Link>
                      */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}